<template>
  <l-status :status="status" :options="options" @input="changeStatus" :disabled="disabled"/>
</template>

<script>
import LStatus from "@/components/status/l-status";
import {Auth, Textes} from "@/js/caller";
import {DataFormat} from "@/js/utils";

export default {
  name: "TexteStatus",
  components: {LStatus},
  props: {
    text: [String, Number],
    fini: [Boolean, Number],
    corrige: [Boolean, Number],
  },
  data() {
    return {
      status: this.getStatus(),
      options: DataFormat.Textes.Status.slice(1),
      disabled: !Auth.IsTeacher()
    }
  },
  methods: {
    getStatus() {
      const {text, fini, corrige} = this;
      console.log(text, fini, corrige);
      console.log(!text ? 0 : (
          !fini ? 1 : (
              corrige ? 3 : 2
          )
      ));
      return !text ? 0 : (
          !fini ? 1 : (
              corrige ? 3 : 2
          )
      );
    },
    getChange(status) {
      return {
        corrige: status === 3 ? 1 : 0,
        fini: status >= 2 ? 1 : 0,
      }
    },
    changeStatus(status) {
      Textes.ChangeStatus({
        id: this.text,
        ...this.getChange(status)
      }).then(() => {
        this.status = status
      })
    }
  },
}
</script>

<style scoped>

</style>